(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gift-registry-form]');
    if (!link) return;
    const variant = document.getElementById(link.dataset.giftRegistryForm)?.querySelector('[name="id"]')?.value;
    const path = link.dataset.giftRegistryPath;
    if (variant && /^\d+$/.test(variant) && /^\/(apps|a|tools|community)\/[a-zA-Z0-9_-]+$/.test(path)) {
      link.href = path + '?variant=' + encodeURIComponent(variant);
    }
  });
})();
